__turbopack_context__.v({
  "Arrow": "index-module__oDJaXq__Arrow",
  "Button": "index-module__oDJaXq__Button",
  "Container": "index-module__oDJaXq__Container",
  "Image": "index-module__oDJaXq__Image",
  "Link": "index-module__oDJaXq__Link",
  "LinkGroup": "index-module__oDJaXq__LinkGroup",
  "Paragraph": "index-module__oDJaXq__Paragraph",
  "Popup": "index-module__oDJaXq__Popup",
  "PopupContent": "index-module__oDJaXq__PopupContent",
  "Positioner": "index-module__oDJaXq__Positioner",
  "Summary": "index-module__oDJaXq__Summary",
});
